import DealershipCard from './DealershipCard';

export default DealershipCard;
